import {findTarget, toSelector, waitForTarget} from './target.js';
import {followPointer, hide, pointerPosition, show, stopFollowingPointer} from './overlay.js';

const api = {
    highlight: async (target, options = {}) => {
        const element = await waitForTarget(target, {timeout: options.timeout ?? 10000});
        await show(element, {
            caption: options.caption ?? '',
            scroll: options.scroll ?? true
        });
        return true;
    },

    clear: () => {
        hide();
        return true;
    },

    showCursor: () => {
        followPointer();
        return true;
    },

    hideCursor: () => {
        stopFollowingPointer();
        return true;
    },

    cursorAt: pointerPosition,

    selectorFor: toSelector,

    exists: (target) => Boolean(findTarget(target)),

    boxOf: (target) => {
        const element = findTarget(target);

        if (!element) {
            return null;
        }

        const {x, y, width, height} = element.getBoundingClientRect();
        return {x, y, width, height};
    },

    version: 1
};

if (typeof window !== 'undefined') {
    window.admicityWalkthrough = api;
}

export default api;
